/** 断网时向用户展示的文案 */
export const OFFLINE_TOAST_MESSAGE =
    'Sin conexión a Internet. verifica tu conexión.';

const OMEGA_POLL_INTERVAL_MS = 100;
const OMEGA_MAX_WAIT_MS = 10000;

function waitForOmegaReady(): Promise<boolean> {
    if (window.Omega?.trackEvent) {
        return Promise.resolve(true);
    }

    return new Promise((resolve) => {
        const deadline = Date.now() + OMEGA_MAX_WAIT_MS;
        const timer = window.setInterval(() => {
            if (window.Omega?.trackEvent) {
                window.clearInterval(timer);
                resolve(true);
            } else if (Date.now() >= deadline) {
                window.clearInterval(timer);
                resolve(false);
            }
        }, OMEGA_POLL_INTERVAL_MS);
    });
}

/**
 * 监听断网：进入页面时已离线会提示；之后 `offline` 事件再提示。
 * @param show 展示断网 toast
 * @param track 断网失败曝光埋点；仅在上报失败（Omega 未就绪或抛错）时，恢复网络后补发一次
 * @returns 取消监听的函数，应在 `onDestroy` 中调用。
 */
export function attachOfflineToast(
    show: (message: string) => void,
    track?: () => void
): () => void {
    let pendingOfflineTrack = false;

    const runTrack = async () => {
        if (!track) return;

        if (!window.Omega?.trackEvent) {
            const ready = await waitForOmegaReady();

            if (!ready) {
                pendingOfflineTrack = true;

                return;
            }
        }

        try {
            track();
        } catch {
            pendingOfflineTrack = true;
        }
    };

    const handleOffline = () => {
        show(OFFLINE_TOAST_MESSAGE);
        void runTrack();
    };

    const handleOnline = () => {
        if (!pendingOfflineTrack || !track) return;

        pendingOfflineTrack = false;
        track();
    };

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    if (!navigator.onLine) {
        queueMicrotask(handleOffline);
    }

    return () => {
        window.removeEventListener('offline', handleOffline);
        window.removeEventListener('online', handleOnline);
    };
}
